import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-staging-login',
  templateUrl: './staging-login.component.html',
  styleUrls: ['./staging-login.component.scss']
})
export class StagingLoginComponent implements OnInit {

  cfid: '';

  constructor(
    private authService: AuthService) { }

  ngOnInit() {
  }

  login(cfid) {
    this.authService.login(cfid);
  }
  login2() {
    this.authService.login(this.cfid);
  }

}
